import CustomTable from '../../../../components/CustomTable';

import { useSelector, useDispatch } from 'react-redux';
import {
    getClientPackages,
    updateClientPackages,
    clientPackagesLoadingStatus,
    clientPackages,
    oneClient,
} from '../../../../redux/slices/clientsSlice';
import { allPackages } from '../../../../redux/slices/insuranceSlice';
import { toast } from 'react-toastify';
import { Space, Switch } from 'antd';
import { Helmet } from 'react-helmet';

export default function ClientInsuranceSubPage() {
    const dispatch = useDispatch();
    const packages = useSelector(clientPackages);
    const allAvailablePackages = useSelector(allPackages);
    const clientsPackagesStatus = useSelector(clientPackagesLoadingStatus);
    const client = useSelector(oneClient);
    const { client_uid } = client;
    const modifiedPackagesForTable = allAvailablePackages?.map((el) => {
        return {
            id: el.id,
            name: el.name,
            type: el.type,
            service_provider:
                el.service_provider === 'mysafety' || !el.is_integration
                    ? 'NI'
                    : el.service_provider,
            active: packages.some((p) => p.id === el.id),
        };
    });
    const onUpdatePackage = async (id, e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const updatedPackages = packages.map((p) => p.id);
        const packageIndex = updatedPackages.indexOf(id);

        if (packageIndex === -1) updatedPackages.push(id);
        else updatedPackages.splice(packageIndex, 1);

        // await dispatch(
        //     updateClientPackages({
        //         clientId: client_uid,
        //         body: { packages: updatedPackages },
        //     }),
        // );
        // dispatch(getClientPackages(client_uid));

        // toast.success('Changes saved successfully');

        try {
            await dispatch(
                updateClientPackages({
                    clientId: client_uid,
                    body: { packages: updatedPackages },
                }),
            ).unwrap?.();

            await dispatch(getClientPackages(client_uid));

            toast.success('Changes saved successfully');
        } catch (error) {
            console.error('Failed to update packages:', error);
        }
    };
    const getFilteredPackages = (data, filter) => {
        const filteredData = data.filter((el) =>
            el?.name.toLowerCase().includes(filter.toLowerCase()),
        );

        return filteredData;
    };

    const activeTypes = {
        title: 'Active',
        render: (_, record) => (
            <Space size="middle">
                <Switch
                    className="details-table__switch--general"
                    checked={record.active}
                    onChange={(checked, e) => onUpdatePackage(record.id, e)}
                />
            </Space>
        ),
    };

    return (
        <>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - Insurance`}</title>
            </Helmet>
            <div className="details-table-wrapper">
                <CustomTable
                    tablePannelTitle="Insurance details"
                    tableHeader={[
                        'Package name',
                        'Package type',
                        'Provider',
                        'Active',
                    ]}
                    functionalCell={{
                        Active: activeTypes,
                    }}
                    columnsDataMap={{
                        'Package name': 'name',
                        'Package type': 'type',
                        Provider: 'service_provider',
                    }}
                    isLoading={clientsPackagesStatus === 'loading'}
                    data={modifiedPackagesForTable}
                    searchInputPlaceholder="Search by name"
                    getFilteredData={getFilteredPackages}
                    withNavigation="edit"
                    withCustomNavigation="/insurance/package"
                    withFilter
                />
            </div>
        </>
    );
}
